<template>
  <div v-if="list.length">
    <!-- 新テンプレート -->
    <div v-if="newTemp">
      <div v-for="(row, i) in list" :key="'l'+i">
        <div class="a4-page">
          <table>
            <tr>
              <td class="title-cell border-r-2 border-b-0" rowspan="2">写真報告書</td>
              <td class="font-bold">住所</td>
              <td class="border-r-2">{{ row.siteAddress }}</td>
              <td class="font-bold">巡回日</td>
              <td class="text-sm font-bold">{{ row.comp }}</td>
            </tr>
            <tr>
              <td class="font-bold border-b-0">物件名</td>
              <td class="py-1 border-r-2 border-b-0">{{ row.siteName }}</td>
              <td class="font-bold border-b-0">巡回者</td>
              <td class="text-sm font-bold border-b-0">{{ row.staff }}</td>
            </tr>
          </table>

          <div v-for="idx in [0, 2, 4]" :key="'it'+idx">
            <div class="flex border-2 border-black mb-5" style="height:75mm">
              <div class="item border-r border-dashed border-black">
                <img class="img" :src="row.items[idx].photo">
                <div class="text">
                  {{ row.items[idx].cleaningText }}
                </div>
              </div>
              <div class="item">
                <img class="img" :src="row.items[idx+1].photo">
                <div class="text">
                  {{ row.items[idx+1].cleaningText }}
                </div>
              </div>
            </div>
          </div>
          <div class="w-fit ml-auto">
            <div>{{ clientName1 }}<span v-if="loading" id="loading" class="text-xss"></span></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 過去テンプレート -->
    <div v-else>
      <div v-for="(row, i) in list" :key="'l'+i">
        <div class="a4-page">
          <table>
            <tr>
              <td class="title-cell border-r-2 border-b-0" rowspan="2">写真報告書</td>
              <td class="font-bold text-sm">住所</td>
              <td class="border-r-2 text-sm">{{ row.siteAddress }}</td>
              <td class="font-bold text-sm">巡回日</td>
              <td class="text-sm font-bold">{{ row.comp }}</td>
            </tr>
            <tr>
              <td class="font-bold border-b-0 text-sm">物件名</td>
              <td class="py-1 border-r-2 border-b-0">{{ row.siteName }}</td>
              <td class="font-bold border-b-0 text-sm">巡回者</td>
              <td class="text-sm font-bold border-b-0">{{ row.staff }}</td>
            </tr>
          </table>

          <div v-for="idx in [0, 2, 4]" :key="'it'+idx">
            <div class="flex border-2 border-black mb-5" style="height:75mm">
              <!-- コメント欄 -->
              <div class="border-r-2 border-black" style="width: 40mm;">
                <div class="flex items-center" style="height:15mm">
                  <div class="text-xs border-r border-black pr-1 h-full"><div class="py-1" style="writing-mode: vertical-rl;">箇所</div></div>
                  <div class="flex-1 text-center whitespace-pre-line text-sm">{{ setName(row.items[idx].classification, row.items[idx+1].classification) }}</div>
                </div>
                <div class="border-t-2 border-black pl-0.5">
                  <div class="text-xs mt-2 mb-5">状況</div>
                  <div class="whitespace-pre-line text-xs">{{ row.items[idx].cleaningText }}</div>
                  <div class="mt-6 whitespace-pre-line text-xs">{{ setText(row.items[idx].cleaningText, row.items[idx+1].cleaningText) }}</div>
                </div>
              </div>
              <!-- 1つ目 -->
              <div class="item border-r border-dashed border-black">
                <img class="img2" :src="row.items[idx].photo">
              </div>
              <!-- 2つ目 -->
              <div class="item">
                <img class="img2" :src="row.items[idx+1].photo">
              </div>
            </div>
          </div>
          <div class="w-fit ml-auto">
            <div>{{ clientName1 }}<span v-if="loading" id="loading" class="text-xss"></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as backend from '@libs/backend'
import { RLS_OLD_FORMAT } from '@libs/constants'
import * as utils from '@libs/utils'
import * as image from '@libs/image'

export default {
  components: {
  },

  data() {
    return {
      list: [],
      // 新しいテンプレート
      newTemp: true,
      // 得意先名（株式会社リプレイスだけは非表示にする）
      clientName1: null,
      // trueになるとPDF化開始
      loading: false
    }
  },

  async created() {
    // クエリからスケジュールID取得
    const id = this.$route.query.id
    const res = await backend.searchData('patrolResult/getRlsPdfById', { id })
    
    if (res.data.data && res.data.data.length) {
      this.list = res.data.data
      const target = this.list[0]

      // 得意先名取得
      if (target.clientName1 && utils.hankaku(target.clientName1).indexOf('ﾘﾌﾟﾚｲｽ') === -1) {
        this.clientName1 = target.clientName1
      }
      // 新フォーマットか否か
      this.isNew(target)

      // 写真をbase64に変換
      for (let i = 0; i < this.list.length; i++) {
        const row = this.list[i]
        for (let j = 0; j < row.items.length; j++) {
          if (row.items[j].photo && row.items[j].photo[0]) {
            row.items[j].photo = image.bufferToDataUrl(row.items[j].photo[0])
          }
        }
      }
    }

    await utils.wait(5000)
    this.loading = true
  },

  methods: {
    /**
     * 過去フォーマット清掃個所
     */
    setName(val, val2) {
      if (val == val2) {
        return val
      }
      return val + '\r\n' + val2
    },

    /**
     * 過去フォーマット状況
     */
    setText(val, val2) {
      if (val == val2) {
        return ''
      }
      return val2
    },

    /**
     * 新フォーマットか否か
     */
    isNew(target) {
      // 新しいテンプレート対応か判定
      if (RLS_OLD_FORMAT.client) {
        // 得意先名で検索
        for (let i = 0; i < RLS_OLD_FORMAT.client.length; i++) {
          const tar = RLS_OLD_FORMAT.client[i]
          if (utils.zenkaku(target.clientName1 + target.clientName2).indexOf(tar) > -1) {
            this.newTemp = false
            return
          }
        }
      }

      if (RLS_OLD_FORMAT.site) {
        // 物件名と住所の一部で検索
        for (let i = 0; i < RLS_OLD_FORMAT.site.length; i++) {
          const tar = RLS_OLD_FORMAT.site[i]
          if (utils.hankaku(target.siteName).indexOf(utils.hankaku(tar.name)) > -1 && (utils.hankaku(target.siteAddress)).indexOf(tar.address) > -1) {
            this.newTemp = false
            return
          }
        }
      }
    }
  },
}
</script>
<style scoped>
.a4-page {
  width: 210mm;
  height: 297mm;
  margin: 0 auto;           /* 中央寄せ */
  padding: 20mm 10mm;            /* 余白（必要に応じて調整） */
  background: white;        /* 背景を白に */
  box-shadow: 0 0 10px rgba(0,0,0,0.1); /* 画面で用紙っぽく見せる影 */
  box-sizing: border-box;   /* padding含めてサイズ調整 */
}

table {
  border-collapse: collapse;
  width: 100%;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
}

td, th {
  border: 1px solid #000;
  text-align: center;       /* 左右中央 */
  vertical-align: middle;   /* 上下中央 */
  padding: 6px;
}

.title-cell {
  background-color: #007b4d; /* 緑色背景 */
  color: #fff;
  font-weight: bold;
  font-size: larger;
  text-align: center;
  width: 40mm;
}

/* 写真・コメント枠 */
.item {
  flex: 1;
  align-items: center;
}

/* 写真 */
.img {
  height: 65mm;
  padding: 10px 10px 5px 10px;
  object-fit: contain;
  width: 100%;
}

/* 過去フォーマット写真 */
.img2 {
  height: 100%;
  padding: 10px 10px 5px 10px;
  object-fit: contain;
  width: 100%;
}

/* コメント */
.text {
  padding: 4px;
  text-align: center;
  font-size: 14px;
}

/* 印刷時だけ適用 */
@media print {
  body {
    width: 210mm;     /* A4幅 */
    height: 297mm;    /* A4高さ */
    font-family: "Arial", sans-serif;
  }

  /* ページをまたぐ要素の制御 */
  .page-break {
    page-break-after: always;
  }

  .a4-page {
    box-shadow: none; /* 印刷時は影を消す */
    page-break-after: always; /* 複数ページ対応 */
  }
}

</style>